import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { FEATURE_SHOW_FIRM_PAGE, ROOT_DOMAIN } from '../../constants';
import PageActions from '../../AppLayout/PageActions';
import Button from '../../Components/Buttons/CustomButton';
import { makeStyles } from '@material-ui/core';
import { FIRM_INACTIVE, FIRM_UNCLAIMED } from './Firm/ListSection';
import { hasApplicationFeature } from '../../utils';

const useStyles = makeStyles(() => ({
    button: {
        minWidth: '12rem',
    },
    buttons: {
        display: 'flex',
        direction: 'column',
        gap: '0.5rem',
        flexWrap: 'wrap',
    },

}));
const ProfessionalPageActions = ({ permalink, firmId, firmUrl, firmVisibility }) => {
    const classes = useStyles();
    return (
        <PageActions title="Profile">
            <div className={classes.buttons}>
                <Button
                    className={classes.button}
                    variant="contained"
                    color="tertiary"
                    href={permalink}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    View Adviser Profile
                </Button>
                <ViewFirmProfileButton
                    firmId={firmId}
                    firmUrl={firmUrl}
                    firmVisibility={firmVisibility}
                />
            </div>
        </PageActions>
    );
};

const ViewFirmProfileButton = ({ firmId, firmUrl, firmVisibility }) => {
    const classes = useStyles();

    if (!hasApplicationFeature(FEATURE_SHOW_FIRM_PAGE)) {
        return null;
    }

    if (!firmId) {
        return null;
    }

    if (firmVisibility === FIRM_INACTIVE) {
        return null;
    }

    if (firmVisibility === FIRM_UNCLAIMED) {
        return null;
    }

    return (
        <Button
            className={classes.button}
            variant="contained"
            color="tertiary"
            href={`${ROOT_DOMAIN}/${firmUrl}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            View Firm Profile
        </Button>
    );
};


const mapStateToProps = ({ basicInfo }) => {
    return {
        permalink: `${ROOT_DOMAIN}/${get(basicInfo, ['permalink', 'url'], '')}`,
        firmUrl: get(basicInfo, ['firm_url'], ''),
        firmId: get(basicInfo, ['firm_id'], ''),
        firmVisibility: get(basicInfo, ['firm_visibility'], ''),
    };
};

export default connect(mapStateToProps)(ProfessionalPageActions);
